<template>
  <div class="expense">
    <template-form
      title="เปรียบเทียบการเสียภาษี"
      description="ระหว่างบุคคลธรรมดาและนิติบุคคลว่าต่างกันอย่างไร"
    >
      <div class="eb-detail">
        <h4>รายจ่ายในสำนักงาน</h4>
        <div>
          นิติบุคคลสามารถนำไปหักค่าใช้จ่ายได้ <br class="isdesktop" />
          ส่วนบุคคลธรรมดาหากมีค่าใช้จ่ายเหล่านี้ก็อาจจะเอามา
          หักค่าใช้จ่ายตามจริงได้นะ
        </div>
      </div>
      <div class="eb-answer">
        รายจ่ายเกี่ยวกับพนักงาน/ เดือน
        <currency
          v-model="employeeExpenses"
          v-on:change="setEmployeeExpenses"
        />
      </div>

      <div class="eb-answer">
        ค่าเช่า/ เดือน
        <currency v-model="rent" v-on:change="setRent" />
      </div>

      <div class="eb-answer">
        ค่าไฟฟ้า/ เดือน
        <currency v-model="electricity" v-on:change="setElectricity" />
      </div>

      <div class="eb-answer">
        ค่าประปา/ เดือน
        <currency v-model="water" v-on:change="setWater" />
      </div>

      <div class="eb-answer">
        ค่าโทรศัพท์/ เดือน
        <currency v-model="phone" v-on:change="setPhone" />
      </div>

      <div class="eb-footer">
        <back-button caption="ย้อนกลับ" />

        <chevron-right-link @clickLink="goNext" caption="ถัดไป" />
      </div>
    </template-form>

    <div class="e-loading">
      <div class="il-active" />
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";

export default {
  name: "Expense",
  components: {
    StateAnswer,
  },
  data() {
    const rent = this.$store.getters["taxInfo/getExpense"].rent;
    const water = this.$store.getters["taxInfo/getExpense"].water;
    const phone = this.$store.getters["taxInfo/getExpense"].phone;
    const electricity = this.$store.getters["taxInfo/getExpense"].electricity;
    const employeeExpenses = this.$store.getters["taxInfo/getExpense"]
      .employeeExpenses;
    return {
      rent,
      electricity,
      water,
      phone,
      employeeExpenses,
    };
  },
  methods: {
    goNext() {
      this.$router.push({ path: "/forms/expense_2" });
    },
    setRent(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "rent",
        value: value,
      });
    },
    setElectricity(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "electricity",
        value: value,
      });
    },
    setWater(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "water",
        value: value,
      });
    },
    setPhone(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "phone",
        value: value,
      });
    },
    setEmployeeExpenses(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "employeeExpenses",
        value: value,
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
.expense {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.eb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 16px;
  max-width: 352px;
  text-align: left;
}
.eb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
}
.eb-footer {
  margin-top: 24px;
  margin-bottom: 31px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 352px;
}
.eb-footer .crl-link {
  justify-content: flex-end;
}
.e-loading {
  width: 100%;
  height: 8px;
  background: #e6e8ec;
  position: relative;
}
.il-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 50%;
  height: 100%;
  background: #008fc1;
}
.isdesktop {
  display: none;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .eb-detail {
    max-width: 514px;
    text-align: center;
    white-space: nowrap;
    margin-bottom: 28px;
  }

  .isdesktop {
    display: inline;
  }
}
</style>
